import React, { ReactNode } from 'react';

import { ThemeProvider } from '../../contexts/ThemeContext';
import { BuildingProvider } from '../../contexts/BuildingContext';

interface Props {
  children: ReactNode;
}

export function GlobalProvider({ children }: Props) {
  return (
    <ThemeProvider>
      <BuildingProvider>{children}</BuildingProvider>
    </ThemeProvider>
  );
}
